import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { IAgent, IAgentFilter } from './agents.interface';
import { AgentsService } from './agents.service';
import { AgentsModalComponent } from './agents-modal/agents-modal.component';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../shared/services/auth.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { ExternalRequestModalComponent } from '../../../shared/components/external-request/external-request-modal/external-request-modal.component';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.css']
})
export class AgentsComponent implements OnInit {
  agents: IAgent[] = [];
  loading: boolean = true;
  thereAreMore: boolean = false;
  filter: IAgentFilter = {
    // filters: {
    //   isDeleted: false
    // },
    sort: '',
    skip: 0,
    limit: 20
  };
  filtered = false;
  totalMoreMinTutorial = false;
  scrollSubscription!: Subscription;
  querySubscription!: Subscription;
  sortOptions: any = {
    "lastname": 'Apellido asc',
    "-lastname": 'Apellido desc',
    "firstname": 'Nombre asc',
    "-firstname": 'Nombre desc',
  };
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  isDev!: boolean;

  constructor(
    private _AgentsService: AgentsService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private router: Router,
    private _route: ActivatedRoute,
    private _AuthService: AuthService,
    private _UtilService: UtilsService,
  ) {
    self = this;
    this.registerStringBroadcast();
    this.registerQueryParamChanges();
  }

  registerQueryParamChanges() {
    this.querySubscription = this._route.queryParams.subscribe(params => {
      if (params['action'] && parseInt(params['tp'] || '0') > (new Date().getTime() - (10 * 1000)) && (params['action'] == 'NEW'))
        setTimeout(() => /*this.openNewClientModal()*/ console.log("boca"));
    })
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.getAgents(true);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    this.filtered=true;
    setTimeout(() => {
      console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getAgents(true);
      }
    }, 1000);
  }

  getAgents(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.agents = [];
      this.clearSelection();
    }
    this._AgentsService.getAgents(this.filter).subscribe((agents: any) => {
      console.log(agents)
      this.agents = _.concat(this.agents, agents);
      const filter: any = this.filter;
      this.thereAreMore = agents.length >= filter.limit;
      this.loading = false;
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getAgents();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
    this.querySubscription.unsubscribe();
  }

  sortAgents(sort: Sort | string) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getAgents(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = { isDeleted: false };
    this.getAgents(true);
  }

  openNewAgentModal() {
    this.openAgentModal({} as IAgent);
  }

  openAgentModal(agent?: IAgent, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '500px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    console.log(agent)
    self.dialogRef = this._dialog.open(AgentsModalComponent, config);
    self.dialogRef.componentInstance.agent = agent;
    self.dialogRef.componentInstance.readOnly = false;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getAgents(true);
    });
  }

  openExternalRequestModal(agent: IAgent) {
    let config = new MatDialogConfig();
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ExternalRequestModalComponent, config);
    self.dialogRef.componentInstance.agent = agent;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      // if (result) this.getAgents(true);
    });
  }

  openGenericExternalRequestModal() {
    let config = new MatDialogConfig();
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ExternalRequestModalComponent, config);
    self.dialogRef.componentInstance.noAgent = true;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      // if (result) this.getAgents(true);
    });
  }

  openDeleteAgentConfirm(agent: IAgent, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Agente",
      message: `Esta seguro que desea eliminar agente ${agent.name || ''}?`,
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._AgentsService.deleteAgent(agent, hardDelete).subscribe(() => {
            if (!hardDelete)  agent.isDeleted = true;
            this.getAgents(true);
          })
        }
      });
  }

  openRestoreAgentConfirm(agent: IAgent) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Agente",
      message: "Esta seguro que desea restaurar '" + agent.name + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._AgentsService.restoreAgent(agent).subscribe(() => {
            agent.isDeleted = false;
            this.getAgents(true);
          })
        }
      });
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.agents.every(agent => {
        const id = agent?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.agents.forEach(agent => {
        const id = agent?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }
}